import { render } from "./Bike.vue?vue&type=template&id=4d04fbbb&scoped=true&ts=true"
import script from "./Bike.vue?vue&type=script&lang=ts"
export * from "./Bike.vue?vue&type=script&lang=ts"

import "./Bike.vue?vue&type=style&index=0&id=4d04fbbb&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d04fbbb"]])

export default __exports__